/**
 * Krunchie Naturals — Reviews Carousel
 * ─────────────────────────────────────────────────────────────
 * HOW TO ADD / EDIT REVIEWS
 * ─────────────────────────────────────────────────────────────
 * 1. UPLOAD your review photos:
 *    Shopify Admin → Online Store → Themes → your theme → Edit code
 *    → Assets folder → "Add a new asset" → upload your image files
 *    Name them clearly, e.g. "review-gloria.jpg", "review-casper-1.jpg"
 *
 * 2. EDIT the REVIEWS array below:
 *    - Set `images` to the exact filenames you uploaded (no path needed)
 *    - Set `images: []` to show the default dog silhouette instead
 *
 * 3. SAVE this file. Changes go live immediately.
 * ─────────────────────────────────────────────────────────────
 */

(function () {
  'use strict';

    /*
   * Reviews are managed from Theme Editor → Reviews Carousel section settings.
   * window.KRUNCHIE_REVIEWS is injected by sections/customer-reviews.liquid
   */
  var REVIEWS = (window.KRUNCHIE_REVIEWS && window.KRUNCHIE_REVIEWS.length > 0)
    ? window.KRUNCHIE_REVIEWS.filter(function(r){ return r && r.author; })
    : [];

  if (!REVIEWS.length) {
    var loadingEl = document.getElementById('reviewsLoading');
    if (loadingEl) loadingEl.style.display = 'none';
    return;
  }

  /*
   * Images come as full Shopify CDN URLs from img_url in the section.
   * Just return the URL as-is.
   */
  function assetUrl(url) { return url || ''; }

  var IMG_ROTATION_MS = 3000;
  var N = REVIEWS.length;

  var $loading = document.getElementById('reviewsLoading');
  var $outer   = document.getElementById('reviewsTrackOuter');
  var $track   = document.getElementById('reviewsTrack');
  var $prev    = document.getElementById('reviewsPrev');
  var $next    = document.getElementById('reviewsNext');
  var $dots    = document.getElementById('reviewsDots');
  var $summary = document.getElementById('reviewsStarSummary');

  if (!$track) return; // reviews section not on this page

  var virtualPos   = N;
  var logicalIndex = 0;
  var isAnimating  = false;
  var trackInner   = null;

  function mod(n, m) { return ((n % m) + m) % m; }

  function starsHtml(rating) {
    var s = '';
    for (var i = 1; i <= 5; i++) s += i <= rating ? '★' : '☆';
    return s;
  }

  function formatDate(str) {
    if (!str) return '';
    try {
      var d = new Date(str + 'T12:00:00');
      return d.toLocaleDateString('en-CA', { year: 'numeric', month: 'short', day: 'numeric' });
    } catch(e) { return ''; }
  }

  function getCardStep() {
    var cards = trackInner.querySelectorAll('.review-card');
    if (!cards.length) return 300;
    var w   = cards[0].getBoundingClientRect().width;
    var gap = parseFloat(getComputedStyle(trackInner).gap) || 24;
    return w + gap;
  }

  function snapTo(pos) {
    var step = getCardStep();
    trackInner.style.transition = 'none';
    trackInner.style.transform  = 'translateX(-' + (pos * step) + 'px)';
    trackInner.getBoundingClientRect();
    trackInner.style.transition = '';
  }

  function slideTo(pos) {
    var step = getCardStep();
    trackInner.style.transform = 'translateX(-' + (pos * step) + 'px)';
  }

  function onTransitionEnd() {
    isAnimating = false;
    if (virtualPos >= 2 * N) { virtualPos -= N; snapTo(virtualPos); }
    else if (virtualPos < N)  { virtualPos += N; snapTo(virtualPos); }
  }

  function updateDots() {
    var dots = $dots.querySelectorAll('.reviews-dot');
    dots.forEach(function(d, i) { d.classList.toggle('active', i === logicalIndex); });
  }

  function navigate(delta) {
    if (isAnimating) return;
    isAnimating   = true;
    virtualPos   += delta;
    logicalIndex  = mod(virtualPos - N, N);
    slideTo(virtualPos);
    updateDots();
  }

  function jumpTo(index) {
    if (isAnimating) return;
    var delta = index - logicalIndex;
    if (delta >  N / 2) delta -= N;
    if (delta < -N / 2) delta += N;
    if (delta === 0) return;
    navigate(delta);
  }

  var DOG_SVG = '<svg viewBox="0 0 120 100" fill="none" xmlns="http://www.w3.org/2000/svg">'
    + '<ellipse cx="60" cy="65" rx="32" ry="24" fill="currentColor"/>'
    + '<circle cx="60" cy="36" r="20" fill="currentColor"/>'
    + '<ellipse cx="42" cy="22" rx="8" ry="14" fill="currentColor" transform="rotate(-18 42 22)"/>'
    + '<ellipse cx="78" cy="22" rx="8" ry="14" fill="currentColor" transform="rotate(18 78 22)"/>'
    + '<circle cx="53" cy="34" r="3" fill="white"/>'
    + '<circle cx="67" cy="34" r="3" fill="white"/>'
    + '<circle cx="54" cy="35" r="1.2" fill="#333"/>'
    + '<circle cx="68" cy="35" r="1.2" fill="#333"/>'
    + '<ellipse cx="38" cy="85" rx="7" ry="11" fill="currentColor" transform="rotate(8 38 85)"/>'
    + '<ellipse cx="82" cy="85" rx="7" ry="11" fill="currentColor" transform="rotate(-8 82 85)"/>'
    + '<path d="M86 64 Q100 58 104 74 Q100 84 90 78" fill="currentColor"/>'
    + '</svg>';

  function buildCard(r) {
    var card = document.createElement('div');
    card.className = 'review-card';

    var imgArea = document.createElement('div');
    imgArea.className = 'review-img-area';

    var validImages = (r.images || []).filter(function(src) { return src && src.trim() !== ''; });

    if (validImages.length > 0) {
      validImages.forEach(function(src, i) {
        var img = document.createElement('img');
        img.src     = assetUrl(src);
        img.alt     = 'Review photo by ' + r.author;
        img.loading = 'lazy';
        if (i === 0) img.classList.add('active');
        imgArea.appendChild(img);
      });
      if (validImages.length > 1) {
        (function(area) {
          var imgs = area.querySelectorAll('img'), cur = 0;
          setInterval(function() {
            imgs[cur].classList.remove('active');
            cur = (cur + 1) % imgs.length;
            imgs[cur].classList.add('active');
          }, IMG_ROTATION_MS);
        })(imgArea);
      }
    } else {
      var ph = document.createElement('div');
      ph.className = 'dog-outline';
      ph.innerHTML = DOG_SVG;
      imgArea.appendChild(ph);
    }
    card.appendChild(imgArea);

    var starsRow = document.createElement('div');
    starsRow.className = 'review-stars';
    var stars = document.createElement('span');
    stars.className = 'stars';
    stars.textContent = starsHtml(r.rating);
    stars.setAttribute('aria-label', r.rating + ' out of 5 stars');
    starsRow.appendChild(stars);
    if (r.verified_purchase) {
      var badge = document.createElement('span');
      badge.className   = 'review-verified';
      badge.textContent = 'Verified Purchase';
      starsRow.appendChild(badge);
    }
    card.appendChild(starsRow);

    if (r.title) {
      var title = document.createElement('h4');
      title.className   = 'review-title';
      title.textContent = r.title;
      card.appendChild(title);
    }

    var body = document.createElement('p');
    body.className   = 'review-body';
    body.textContent = r.body;
    card.appendChild(body);

    var footer = document.createElement('div');
    footer.className = 'review-footer';
    var authorEl = document.createElement('span');
    authorEl.className   = 'review-author';
    authorEl.textContent = r.author;
    footer.appendChild(authorEl);
    if (r.date) {
      var dateEl = document.createElement('span');
      dateEl.className   = 'review-date';
      dateEl.textContent = formatDate(r.date);
      footer.appendChild(dateEl);
    }
    card.appendChild(footer);
    return card;
  }

  function render() {
    var avg     = REVIEWS.reduce(function(s, r) { return s + r.rating; }, 0) / N;
    var rounded = Math.round(avg * 10) / 10;
    $summary.innerHTML =
      '<span class="star-row">' + starsHtml(Math.round(avg)) + '</span>' +
      '<span class="avg-num">' + rounded.toFixed(1) + '</span>';

    trackInner = document.createElement('div');
    trackInner.className = 'reviews-track-inner';
    REVIEWS.forEach(function(r) { trackInner.appendChild(buildCard(r)); });
    REVIEWS.forEach(function(r) { trackInner.appendChild(buildCard(r)); });
    REVIEWS.forEach(function(r) { trackInner.appendChild(buildCard(r)); });
    $track.appendChild(trackInner);

    REVIEWS.forEach(function(_, i) {
      var dot = document.createElement('button');
      dot.className = 'reviews-dot' + (i === 0 ? ' active' : '');
      dot.setAttribute('aria-label', 'Go to review ' + (i + 1));
      dot.addEventListener('click', function() { jumpTo(i); });
      $dots.appendChild(dot);
    });

    $loading.style.display = 'none';
    $outer.style.display   = 'flex';

    requestAnimationFrame(function() { snapTo(virtualPos); });
  }

  $prev.addEventListener('click', function() { navigate(-1); });
  $next.addEventListener('click', function() { navigate(1); });
  $track.addEventListener('transitionend', function(e) {
    if (trackInner && e.target === trackInner) onTransitionEnd();
  });

  var touchStartX = 0;
  $track.addEventListener('touchstart', function(e) {
    touchStartX = e.touches[0].clientX;
  }, { passive: true });
  $track.addEventListener('touchend', function(e) {
    var dx = e.changedTouches[0].clientX - touchStartX;
    if (Math.abs(dx) > 50) navigate(dx < 0 ? 1 : -1);
  }, { passive: true });

  var resizeTimer;
  window.addEventListener('resize', function() {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function() { snapTo(virtualPos); }, 120);
  });

  render();

})();
